import { Box, Grid, Typography } from '@mui/material';
import { formatPounds } from '@acorn-portal/shared/src/utils';
import { useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import PriceBreakdown from '@acorn-portal/shared/src/components/display/price-breakdown';
import RestartBraintreeCardPaymentSection from './braintree-card-payment-section';

interface IProps {
	toggleModal: (open: boolean) => void;
}

const RestartCardPaymentOption = ({ toggleModal }: IProps) => {
	const policy = useAppSelector((redux) => redux.fullPolicy);

	const { quoteData } = useAppSelector((state) => state.subscription);

	const totalToPay =
		quoteData?.quoteResponse.underwrittenOptions?.[0].paymentCollectionOptions?.[0].totalAmountPayable ?? 0;
	const fee = quoteData?.quoteResponse.underwrittenOptions?.[0].price?.policyAdministrationFee ?? 0;
	return (
		<Box>
			<Grid
				container
				sx={{
					border: 1,
					borderColor: 'grey.300',
					p: 2,
					mb: 4,
					borderRadius: 2,
				}}
			>
				<Grid container sx={{ flexDirection: 'column' }}>
					<Grid sx={{ textAlign: { xs: 'left' } }}>
						<Typography component='h3' color='primary'>
							Single Card Payment
						</Typography>
						<Typography fontSize={44} fontWeight='bold' color='primary' lineHeight={1}>
							{formatPounds(totalToPay)}
						</Typography>
						<Grid flex={1}>
							<Typography fontSize={16}>Payment Amount</Typography>
						</Grid>

						<PriceBreakdown price={totalToPay} fee={fee} product={policy.product} />
					</Grid>
				</Grid>
			</Grid>
			<RestartBraintreeCardPaymentSection payInFullAmount={totalToPay} toggleModal={toggleModal} />
		</Box>
	);
};

export default RestartCardPaymentOption;
